import React, { createContext, useContext, useState } from "react";

const ClientContext = createContext();

export const ClientStatusProvider = ({ children }) => {
  const [clientStatusUpdated, setClientStatusUpdated] = useState(false);

  const notifyClientStatusChange = () => {
    setClientStatusUpdated((prev) => !prev); // triggers refresh in dependent components
  };

  return (
    <ClientContext.Provider value={{ clientStatusUpdated, notifyClientStatusChange }}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClientStatus = () => useContext(ClientContext);
